/*
  NordicVend: trygghetslistans skript (snippets/NV-TRUST-LIST.liquid).
  Låg tidigare inline i snippeten. Som egen fil cachas den mellan sidvisningar.
  Laddas med defer från snippeten. Värden från Liquid läses från skripttaggens
  data-attribut (document.currentScript), så filen innehåller ingen Liquid.
*/
(function () {
  const overlay    = document.getElementById('nvTpOverlay');
  const panel      = document.getElementById('nvTpPanel');
  const closeBtn   = document.getElementById('nvTpClose');
  const titleEl    = document.getElementById('nvTpTitle');
  const bodyEl     = document.getElementById('nvTpBody');
  const ctaEl      = document.getElementById('nvTpCta');
  const contactPanel = document.getElementById('nvTpContactPanel');
  const contactClose = document.getElementById('nvTpContactClose');
  const contactForm  = document.getElementById('nvTpContactForm');
  const thanks       = document.getElementById('nvTpThanks');
  const thanksText   = document.getElementById('nvTpThanksText');
  const buttons    = Array.prototype.slice.call(document.querySelectorAll('.nv-trust__item--btn'));

  if (!overlay || !panel || !contactPanel) return;

  // Flytta overlay och paneler till <body> så de aldrig hamnar
  // "instängda" i en förälder med overflow:hidden eller egen z-index.
  NVPanel.toBody(overlay, panel, contactPanel);

  // --- Innehåll per rad ---
  // Trygghetsgarantins siffror från temainställningarna (data-erb-proc och data-erb-dagar på .nv-trust)
  const trustEl = document.querySelector('.nv-trust');
  const ERB_PROC = (trustEl && trustEl.getAttribute('data-erb-proc')) || '10';
  const ERB_DAGAR = (trustEl && trustEl.getAttribute('data-erb-dagar')) || '60';
  const content = {
    trygghet: {
      title: ERB_DAGAR + ' dagars trygghetsgaranti',
      intro: 'Inte nöjd? Ansök inom ' + ERB_DAGAR + ' dagar. Blir ansökan godkänd behåller du produkten och får minst ' + ERB_PROC + ' % av priset tillbaka.',
      bullets: [
        ERB_DAGAR + ' dagar att bestämma dig',
        'Du behåller produkten, inget returkrångel',
        function () {
          // Beloppet för vald variant, både exkl. och inkl. moms (från NV-ERB-BELOPP, uppdateras vid variantbyte)
          const el = trustEl && trustEl.querySelector('[data-nv-erb="garanti"]');
          const ex = el ? Number(el.getAttribute('data-cents-exkl')) : 0;
          const ink = el ? Number(el.getAttribute('data-cents-inkl')) : 0;
          if (!ex || !ink) return 'Minst ' + ERB_PROC + ' % av priset tillbaka vid godkänd ansökan';
          const kr = function (c) { return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(Math.round(c / 100)) + '&nbsp;kr'; };
          return 'Minst ' + ERB_PROC + ' % av priset tillbaka vid godkänd ansökan, på den här produkten minst ' + kr(ex) + ' exkl. moms (' + kr(ink) + ' inkl. moms)';
        },
        'Gäller både företag och privatpersoner'
      ],
      stepsTitle: 'Så fungerar det',
      steps: [
        ['Ansök inom ' + ERB_DAGAR + ' dagar', 'Räknat från dagen du fick din leverans.'],
        ['Vi går igenom ansökan', 'Du får besked om beslutet och beloppet innan något betalas ut.'],
        ['Du behåller produkten', 'Blir ansökan godkänd betalar vi tillbaka vår vinstmarginal, alltid minst ' + ERB_PROC + ' % av priset.']
      ],
      outro: 'Ett extra löfte utöver dina rättigheter enligt lag, och det kostar ingenting.',
      link2: { href: '/pages/anmal-garantiarende', text: 'Ansök om trygghetsgarantin' },
      link: '/pages/garantier',
      cta: 'Se våra garantier'
    },
    reservdel: {
      title: '24 månaders reservdelsgaranti',
      intro: 'Går något sönder på grund av ett fel i produkten? Då skickar vi en ny reservdel.',
      bullets: [
        '24 månaders reservdelsgaranti ingår som standard',
        'Vi skickar nya reservdelar snabbt',
        'Täcker fel i tillverkning, material och konstruktion'
      ],
      stepsTitle: 'Om något går sönder',
      steps: [
        ['Anmäl felet', 'Ange produkt, ordernummer och gärna serienummer.'],
        ['Vi återkommer', 'Inom 1 till 2 arbetsdagar. Vi går igenom varje ärende själva, så att du får rätt besked direkt.'],
        ['Du får en ny del', 'Vi skickar reservdelen, utan krångel.']
      ],
      outro: 'Dina rättigheter enligt lag gäller som vanligt, garantin kommer utöver dem.',
      link2: { href: '/pages/anmal-garantiarende', text: 'Anmäl ett garantiärende' },
      link: '/pages/garantier',
      cta: 'Se våra garantier'
    }
    // Kontakt har en egen panel med formulär, se "Panel 2" i HTML:en.
  };

  function renderBody(data) {
    if (data.html) return data.html;
    let html = '';
    if (data.intro) html += '<p>' + data.intro + '</p>';
    if (data.bullets && data.bullets.length) {
      html += '<ul class="nv-tp-list">' +
        data.bullets.map(function (b) { return '<li>' + (typeof b === 'function' ? b() : b) + '</li>'; }).join('') +
        '</ul>';
    }
    if (data.steps && data.steps.length) {
      if (data.stepsTitle) html += '<div class="nv-tp-h3 nv-h3">' + data.stepsTitle + '</div>';
      html += '<ol class="nv-tp-steps">' +
        data.steps.map(function (s) { return '<li><strong>' + s[0] + '</strong>' + s[1] + '</li>'; }).join('') +
        '</ol>';
    }
    if (data.outro) html += '<p class="nv-tp-note">' + data.outro + '</p>';
    if (data.link2) html += '<p><a class="nv-tp-link" href="' + data.link2.href + '">' + data.link2.text + '</a></p>';
    return html;
  }

  // Fokus: flyttas in i panelen när den öppnas och tillbaka till knappen
  // som öppnade den när den stängs (samma mönster som PRODUCT-BADGES).
  // Stängda paneler är inert, så de går inte att tabba till och syns inte
  // för skärmläsare. Tab stannar i den öppna panelen, Escape stänger.
  let lastFocus = null;

  function isAnyOpen() {
    return panel.classList.contains('is-open') || contactPanel.classList.contains('is-open');
  }

  function openWrap() {
    if (panel.classList.contains('is-open')) return panel;
    if (contactPanel.classList.contains('is-open')) return contactPanel;
    return null;
  }

  function hideAll() {
    [panel, contactPanel].forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
      p.setAttribute('inert', '');
    });
    buttons.forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    overlay.classList.remove('is-open');
    document.body.classList.remove('nv-tp-no-scroll');
  }

  function closeAll() {
    const wasOpen = isAnyOpen();
    hideAll();
    if (wasOpen && lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  // opts.focus: element som ska få fokus, eller false för att lämna fokus där det är
  function openPanel(wrap, btn, opts) {
    opts = opts || {};
    // Klick på en redan öppen rad stänger panelen igen.
    const wasOpen = wrap.classList.contains('is-open') &&
                    (!btn || btn.getAttribute('aria-expanded') === 'true');
    if (wasOpen) { closeAll(); return; }
    NVPanel.opening('trust');
    // Kom ihåg var fokus fanns, men aldrig ett fält inne i en panel som strax döljs.
    const active = document.activeElement;
    const insidePanel = active && (panel.contains(active) || contactPanel.contains(active));
    if (!isAnyOpen() || !lastFocus) {
      lastFocus = btn || (insidePanel ? null : active);
    } else if (btn) {
      lastFocus = btn;
    }
    hideAll();
    wrap.removeAttribute('inert');
    wrap.classList.add('is-open');
    wrap.setAttribute('aria-hidden', 'false');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    overlay.classList.add('is-open');
    document.body.classList.add('nv-tp-no-scroll');
    if (opts.focus === false) return;
    const target = opts.focus || wrap.querySelector('.nv-tp-close');
    if (target && typeof target.focus === 'function') {
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = btn.getAttribute('data-tp-key');

      // Kontaktformuläret har en egen panel, eftersom det är ett Liquid-formulär.
      if (key === 'kontakt') {
        openPanel(contactPanel, btn);
        return;
      }

      const data = content[key];
      if (!data) return;
      titleEl.textContent = data.title;
      bodyEl.innerHTML = renderBody(data);
      if (data.link) {
        ctaEl.href = data.link;
        ctaEl.textContent = data.cta || 'Se våra garantier';
        ctaEl.style.display = '';
      } else {
        ctaEl.style.display = 'none';
      }
      openPanel(panel, btn);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeAll);
  if (contactClose) contactClose.addEventListener('click', closeAll);
  overlay.addEventListener('click', closeAll);
  /* Escape och Tab: NVPanel (snippets/NV-PANEL-CORE.liquid) */
  NVPanel.keys(openWrap, closeAll);
  NVPanel.register('trust', isAnyOpen, closeAll);

  // WebMCP: fyller en agent (eller något annat) i kontaktformuläret medan
  // panelen är stängd öppnas den, så att kunden ser vad som fylls i.
  // Stängd panel är inert, därför lyssnas på input och change, inte focusin.
  if (contactForm) {
    const ensureContactOpen = function () {
      if (contactPanel.classList.contains('is-open')) return;
      const b = document.querySelector('.nv-trust__item--btn[data-tp-key="kontakt"]');
      openPanel(contactPanel, b, { focus: false });
    };
    contactForm.addEventListener('input', ensureContactOpen);
    contactForm.addEventListener('change', ensureContactOpen);
  }

  const productTitle = document.currentScript.getAttribute('data-produkt') || '';

  // --- Bygg det dolda "contact[body]"-fältet innan kontaktformuläret skickas ---
  // --- Kontroll i JS i stället för webbläsarens bubblor, samma som företagsfakturan ---
  // Fel fält markeras, pekar på felrutan och det första får fokus.
  let tpSkickar = false;
  const tpFalt = contactForm ? {
    namn: contactForm.querySelector('#nv-tp-namn'),
    epost: contactForm.querySelector('#nv-tp-epost'),
    meddelande: contactForm.querySelector('#nv-tp-meddelande')
  } : {};
  const tpFelruta = document.getElementById('nvTpContactError');
  const tpVarde = function (key) { return tpFalt[key] && tpFalt[key].value ? tpFalt[key].value.trim() : ''; };
  const tpGiltig = function (el) {
    el.classList.remove('nv-tp-invalid');
    el.removeAttribute('aria-invalid');
    el.removeAttribute('aria-describedby');
  };
  const tpMarkera = function (el, rutaId) {
    el.classList.add('nv-tp-invalid');
    el.setAttribute('aria-invalid', 'true');
    el.setAttribute('aria-describedby', rutaId);
  };
  const tpKontrollera = function () {
    const fel = [];
    const felFalt = [];
    Object.keys(tpFalt).forEach(function (k) { if (tpFalt[k]) tpGiltig(tpFalt[k]); });
    if (tpFelruta) { tpFelruta.hidden = true; tpFelruta.textContent = ''; }
    const bad = function (key, msg) {
      fel.push(msg);
      if (tpFalt[key]) felFalt.push(tpFalt[key]);
    };
    if (!tpVarde('namn')) bad('namn', 'Fyll i ditt namn.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tpVarde('epost'))) bad('epost', 'Ange en giltig e-postadress.');
    if (!tpVarde('meddelande')) bad('meddelande', 'Skriv ditt meddelande.');
    if (!fel.length) return true;
    if (tpFelruta) {
      tpFelruta.textContent = fel.join(' ');
      tpFelruta.hidden = false;
      felFalt.forEach(function (el) { tpMarkera(el, tpFelruta.id); });
    }
    if (felFalt.length) felFalt[0].focus();
    return false;
  };
  if (contactForm) {
    /* Avbrutet formulär mejlas till oss (assets/nv-form-abandon.js) */
    contactForm.setAttribute('data-nv-abandon', 'Kontakt från produktsida');
    contactForm.noValidate = true;
    contactForm.addEventListener('submit', function (e) {
      if (tpSkickar) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      // Serverns felruta från förra försöket ersätts av den nya kontrollen
      const serverFel = document.getElementById('nvTpContactErrors');
      if (serverFel) serverFel.hidden = true;
      if (!tpKontrollera()) { e.preventDefault(); e.stopImmediatePropagation(); }
    });
    contactForm.addEventListener('input', function (e) {
      if (e.target.classList && e.target.classList.contains('nv-tp-invalid')) tpGiltig(e.target);
    });
  }

  /* Svensk tid oavsett var kunden är: dd/mm/åååå hh:mm:ss */
  const stockholmDelar = function (d) {
    const p = {};
    try {
      new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'Europe/Stockholm', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) {}
    if (!p.year) {
      const pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      p.year = '' + d.getFullYear(); p.month = pad(d.getMonth() + 1); p.day = pad(d.getDate());
      p.hour = pad(d.getHours()); p.minute = pad(d.getMinutes()); p.second = pad(d.getSeconds());
    }
    if (p.hour === '24') p.hour = '00';
    return p;
  };
  const stockholmTid = function () {
    const p = stockholmDelar(new Date());
    return p.day + '/' + p.month + '/' + p.year + ' ' + p.hour + ':' + p.minute + ':' + p.second;
  };
  const nyttArendenummer = function () {
    const p = stockholmDelar(new Date());
    return 'NV-' + p.year.slice(-2) + p.month + p.day + '-' + (100000 + Math.floor(Math.random() * 900000));
  };

  if (contactForm) {
    /* Utan JS skickas textrutan som contact[body]. Med JS byggs meddelandet i det
       dolda fältet i stället, och textrutan döps om så att den inte skickas två gånger. */
    const msgArea = contactForm.querySelector('#nv-tp-meddelande');
    if (msgArea) msgArea.setAttribute('name', 'nv_message');
    let contactHidden = contactForm.querySelector('input[name="contact[body]"]');
    if (!contactHidden) {
      contactHidden = document.createElement('input');
      contactHidden.type = 'hidden';
      contactHidden.name = 'contact[body]';
      contactForm.appendChild(contactHidden);
    }
    /* Ett ärendenummer per sidvisning. Ligger även på formuläret (data-nv-ref) så att
       mejlet om avbrutet formulär kan använda samma nummer. */
    const arendenummer = nyttArendenummer();
    contactForm.setAttribute('data-nv-ref', arendenummer);
    contactForm.setAttribute('data-nv-rubrik', 'KONTAKTFÖRFRÅGAN');
    contactForm.addEventListener('submit', function () {
      const msg = contactForm.querySelector('[name="nv_message"]')?.value || '';
      const telEl = contactForm.querySelector('[name="contact[phone]"]');
      const tel = telEl && telEl.value ? telEl.value.trim() : '';
      contactHidden.value =
        'KONTAKTFÖRFRÅGAN / ' + stockholmTid() + '\n\n' +
        'Sida: ' + location.pathname + '\n' +
        'Produkt: ' + productTitle + '\n' +
        'Namn: ' + tpVarde('namn') + '\n' +
        'E-post: ' + tpVarde('epost') + '\n' +
        'Telefon: ' + (tel || 'Ej angivet') + '\n' +
        'Meddelande:\n' + msg.trim() + '\n\n' +
        'Ärendenummer: ' + arendenummer + '\n' +
        'Tidsstämpel: ' + stockholmTid();
      try {
        sessionStorage.setItem('nvContactForm', 'kontakt');
        sessionStorage.setItem('nvContactMsg', msg);
      } catch (e) {}
    });

    // Dubbelklick: knappen låses när formuläret skickas och låses upp igen
    // om kunden kommer tillbaka med bakåtknappen (bfcache).
    const tpKnapp = contactForm.querySelector('.nv-tp-submit');
    const tpKnappText = tpKnapp ? tpKnapp.textContent : '';
    contactForm.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      tpSkickar = true;
      /* Formuläret skickas och sidan laddas om: inget mejl om avbrutet formulär */
      contactForm.setAttribute('data-nv-skickat', 'true');
      if (tpKnapp) {
        tpKnapp.disabled = true;
        tpKnapp.setAttribute('aria-busy', 'true');
        tpKnapp.textContent = 'Skickar…';
      }
    });
    window.addEventListener('pageshow', function () {
      tpSkickar = false;
      contactForm.removeAttribute('data-nv-skickat');
      if (tpKnapp) {
        tpKnapp.disabled = false;
        tpKnapp.removeAttribute('aria-busy');
        tpKnapp.textContent = tpKnappText;
      }
    });
  }

  // Om Shopify avvisar formuläret (fel e-post, robotkontroll som inte gick igenom o.s.v.)
  // renderas sidan om med felen i panelen. Öppna panelen igen och fyll i meddelandet.
  const contactErrors = document.getElementById('nvTpContactErrors');
  if (contactForm && contactErrors) {
    const errHash = window.location.hash;
    let errFlag = '';
    try { errFlag = sessionStorage.getItem('nvContactForm') || ''; } catch (e) {}
    // Shopify ger alla kontaktformulär på sidan samma fel. Hashen avgör, och
    // markeringen från submit används bara när hashen saknas. Den läses en gång.
    const isThisForm = errHash === '#nvTpContactForm' || (!errHash && errFlag === 'kontakt');
    if (errFlag === 'kontakt') {
      try { sessionStorage.removeItem('nvContactForm'); } catch (e) {}
    }
    if (!isThisForm) {
      contactErrors.parentNode.removeChild(contactErrors);
    } else {
      const msgField = contactForm.querySelector('[name="nv_message"]');
      if (msgField && !msgField.value) {
        let saved = '';
        try { saved = sessionStorage.getItem('nvContactMsg') || ''; } catch (e) {}
        if (!saved) {
          // Reserv: plocka ut meddelandet ur den text Shopify skickar tillbaka.
          let prev = '';
          try {
            const prevEl = document.getElementById('nvTpContactPrev');
            prev = prevEl ? JSON.parse(prevEl.textContent || '""') || '' : '';
          } catch (e) {}
          const start = prev.indexOf('Meddelande:\n');
          const end = prev.indexOf('\nÄrendenummer: ', start);
          if (start !== -1) saved = prev.slice(start + 12, end > start ? end : undefined).trim();
        }
        if (saved) msgField.value = saved;
      }
      // Fälten som Shopify underkände markeras och pekar på felrutan
      const serverMap = { name: 'namn', email: 'epost', body: 'meddelande' };
      (contactErrors.getAttribute('data-nv-fields') || '').split(/\s+/).forEach(function (f) {
        const el = tpFalt[serverMap[f]];
        if (el) tpMarkera(el, contactErrors.id);
      });
      const contactBtn = document.querySelector('.nv-trust__item--btn[data-tp-key="kontakt"]');
      openPanel(contactPanel, contactBtn, { focus: contactErrors });
    }
  }

  // Efter lyckad postning laddar Shopify om sidan med ?contact_posted=true
  // och formulärets id som hash. Stäng panelen och visa bekräftelsen.
  const params = new URLSearchParams(window.location.search);
  if (params.get('contact_posted') === 'true') {
    closeAll();
    let sent = '';
    try { sent = sessionStorage.getItem('nvContactForm') || ''; } catch (e) {}
    // Hashen kommer från formulärets action (/contact#id) och är den säkra signalen,
    // sessionStorage används bara som reserv om hashen av någon anledning saknas.
    const formByHash = { '#nvTpContactForm': 'kontakt' };
    const hash = window.location.hash;
    let which = hash ? (formByHash[hash] || '') : sent;
    if (which !== 'kontakt') which = '';
    if (which && thanks) {
      try {
        sessionStorage.removeItem('nvContactForm');
        sessionStorage.removeItem('nvContactMsg');
      } catch (e) {}
      const text = thanks.getAttribute('data-text-' + which);
      if (text && thanksText) thanksText.textContent = text;
      thanks.classList.add('is-visible');
      // Rensa bort flaggan ur adressfältet så bekräftelsen inte visas igen vid omladdning.
      if (window.history && window.history.replaceState) {
        params.delete('contact_posted');
        const query = params.toString();
        window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
      }
      window.setTimeout(function () {
        // Fokus till bekräftelsen, så att den läses upp
        thanks.focus({ preventScroll: true });
        if (thanks.scrollIntoView) thanks.scrollIntoView({ block: 'center', behavior: (window.nvScrollBehavior ? window.nvScrollBehavior() : 'smooth') });
      }, 300);
    }
  }
})();
